import React from 'react';
import styles from './toolbar.module.css';
import { DateField } from '../dropdown';

interface ToolbarDateProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

/** Compact labelled date picker (ISO yyyy-mm-dd), sized to match the bar. */
export const ToolbarDate: React.FC<ToolbarDateProps> = ({ label, value, onChange }) => (
  <div className={styles.dateFieldWrap}>
    <DateField label={label} value={value || null} onChange={(iso) => onChange(iso ?? '')} />
  </div>
);
